






































import { Component, Vue } from 'vue-property-decorator';
import { DashboardModule } from '@/store/Dashboard/DashboardModule';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'LiabilitiesWidget' })
export default class extends Vue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    async beforeMount() {
        await DashboardModule.getCashbackTotals();
    }

    get loading() {
        return DashboardModule.loadingCashback;
    }

    get cashback() {
        return DashboardModule.cashback;
    }

}
